module.exports = __webpack_public_path__ + "img/bl.8fcd8041.svg";